/**
 * Language codes for languages supported by the git-backed internationalization feature.
 */
export enum SupportedLanguages {
  DE = 'de', // German
  EN = 'en', // English
  ES = 'es', // Spanish
  FR = 'fr', // French
  IT = 'it', // Italian
  JA = 'ja', // Japanese
  PT = 'pt', // Portuguese
  ZH = 'zh', // Chinese
}

// Array export for JS usage
export const SupportedLanguagesArray: SupportedLanguages[] = Object.values(SupportedLanguages);
